/* ==========================================================
   ma-social-proof.js — Quote slider
   3 per page on desktop (≥750px), 1 per page on mobile.
   ========================================================== */

(function () {
  'use strict';

  class SocialProofSlider {
    constructor(el) {
      this.el       = el;
      this.track    = el.querySelector('.ma-social-proof__track');
      this.slides   = Array.from(el.querySelectorAll('.ma-social-proof__slide'));
      this.dots     = el.querySelector('.ma-social-proof__dots');
      this.index    = 0; // current slide index (not page)
      this.touchX   = 0;
      this.touchY   = 0;
      this.dragging = false;

      if (this.slides.length < 2) return; // nothing to slide

      this.buildDots();
      this.go(0, false);
      this.bindEvents();
    }

    // ── Helpers ───────────────────────────────────────────────

    get perPage() {
      return window.innerWidth >= 750 ? 3 : 1;
    }

    get totalPages() {
      return Math.ceil(this.slides.length / this.perPage);
    }

    get currentPage() {
      return Math.floor(this.index / this.perPage);
    }

    // ── Dots ──────────────────────────────────────────────────

    buildDots() {
      this.dots.innerHTML = '';
      if (this.totalPages <= 1) return;
      for (let i = 0; i < this.totalPages; i++) {
        const btn = document.createElement('button');
        btn.className = 'ma-social-proof__dot';
        btn.setAttribute('type', 'button');
        btn.setAttribute('aria-label', 'Go to page ' + (i + 1));
        btn.addEventListener('click', () => this.go(i * this.perPage));
        this.dots.appendChild(btn);
      }
    }

    updateDots() {
      Array.from(this.dots.children).forEach((dot, i) => {
        dot.classList.toggle('ma-social-proof__dot--active', i === this.currentPage);
      });
    }

    // ── Navigation ────────────────────────────────────────────

    go(index, animate = true) {
      const max = (this.totalPages - 1) * this.perPage;
      this.index = Math.max(0, Math.min(index, max));

      const slideWidth = this.slides[0].offsetWidth;
      this.track.style.transition = animate ? 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'none';
      this.track.style.transform  = `translateX(${-this.index * slideWidth}px)`;

      this.updateDots();
    }

    next() {
      const nextIndex = this.index + this.perPage;
      this.go(nextIndex < this.slides.length ? nextIndex : 0);
    }

    prev() {
      const prevIndex = this.index - this.perPage;
      this.go(prevIndex >= 0 ? prevIndex : (this.totalPages - 1) * this.perPage);
    }

    // ── Events ────────────────────────────────────────────────

    bindEvents() {
      // Touch swipe
      this.track.addEventListener('touchstart', (e) => {
        this.touchX   = e.touches[0].clientX;
        this.touchY   = e.touches[0].clientY;
        this.dragging = true;
      }, { passive: true });

      this.track.addEventListener('touchend', (e) => {
        if (!this.dragging) return;
        this.dragging = false;
        const dx = e.changedTouches[0].clientX - this.touchX;
        const dy = e.changedTouches[0].clientY - this.touchY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
          dx < 0 ? this.next() : this.prev();
        }
      }, { passive: true });

      // Mouse drag (desktop)
      let mouseStartX = 0;
      let isDragging  = false;

      this.track.addEventListener('mousedown', (e) => {
        mouseStartX = e.clientX;
        isDragging  = true;
        this.track.style.cursor = 'grabbing';
      });

      window.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        e.preventDefault();
      });

      window.addEventListener('mouseup', (e) => {
        if (!isDragging) return;
        isDragging = false;
        this.track.style.cursor = '';
        const dx = e.clientX - mouseStartX;
        if (Math.abs(dx) > 40) {
          dx < 0 ? this.next() : this.prev();
        }
      });

      // Resize — rebuild for new perPage
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          // Snap to start of the nearest page
          this.index = this.currentPage * this.perPage;
          this.buildDots();
          this.go(this.index, false);
        }, 150);
      });
    }
  }

  // ── Boot ──────────────────────────────────────────────────

  function boot() {
    document.querySelectorAll('.ma-social-proof__slider').forEach((el) => {
      new SocialProofSlider(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
